import { extendTheme } from "@chakra-ui/react";
import { 
  LOMA_BLACK, 
  LOMA_GRAY_HOVER, 
  LOMA_GRAY_LIGHT 
} from "./constants/colors";

const theme = extendTheme({
  fonts: {
    heading: "'Bison', sans-serif",
    body: "'Inter Tight', sans-serif",
  },
  styles: {
    global: {
      body: {
        background: "transparent !important",
        color: "white",
      },
    },
  },
  components: {
    Input: {
      baseStyle: {
        field: {
          background: "rgba(255,255,255,0.08)",
          border: "1px solid lightgray",
          color: "gray.800",
          _placeholder: { color: "gray.600" },
          fontSize: "sm",
          height: "38px",
          borderRadius: "md",
          backdropFilter: "blur(4px)",
          display: "flex",
          alignItems: "center"
        },
      },
      variants: {
        outline: {
          field: {
            border: "1px solid lightgray",
            transition: "all 0.2s ease-in-out",
            _hover: {
              borderColor: "gray.400",
              backgroundColor: "rgba(255, 255, 255, 0.12)"
            },
            _focus: {
              borderColor: "gray.500",
              boxShadow: "none"
            }
          }
        }
      }
    },
    InputGroup: {
      baseStyle: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        borderRadius: "md"
      },
    },
    Button: {
      baseStyle: {
        borderRadius: "md",
        px: 5,
        height: "38px",
        fontSize: "sm",
        bg: "transparent",
        color: LOMA_BLACK,
        border: "1px solid lightgray",
        backdropFilter: "blur(4px)",
        transition: "all 0.2s ease-in-out",
        _hover: {
          bg: "rgba(255, 255, 255, 0.12) !important",
          color: `${LOMA_BLACK} !important`,
          borderColor: `gray.400 !important`,
        },
      },
      variants: {
        solid: {
          bg: "transparent",
          color: LOMA_BLACK,
          border: "1px solid lightgray",
          transition: "all 0.2s ease-in-out",
          _hover: {
            bg: "rgba(255, 255, 255, 0.12)",
            color: LOMA_BLACK,
            borderColor: "gray.400",
          },
          _loading: {
            bg: "transparent",
            opacity: 0.7,
            _hover: { bg: "rgba(255, 255, 255, 0.12)" },
          },
        },
        primary: {
          bg: LOMA_BLACK,
          color: "white",
          border: "1px solid transparent",
          transition: "all 0.2s ease-in-out",
          _hover: {
            bg: LOMA_GRAY_HOVER,
            color: "white",
          },
          _loading: {
            bg: LOMA_BLACK,
            opacity: 0.7,
            _hover: { bg: LOMA_GRAY_HOVER },
          },
        },
      },
      defaultProps: {
        variant: "solid",
      },
    },
  },
});

export default theme;